import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Danger from "components/Typography/Danger.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Footer from "components/Footer/Footer.jsx";
import PreLoginHeader from "components/Header/PreLoginHeader.jsx";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import {getApiHeaders} from "../../assets/helpers/apiHelper";
import { API_ROOT } from 'api-config';
import { verifyPassword } from "../../assets/helpers/formHelper";

class EnterNewPassword extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.goToDashboard = this.goToDashboard.bind(this);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      password1: "",
      password1State: "",
      password2: "",
      password2State: "",
      responseMessage: "",
      showPasswordMismatch: false,
      loginButtonDisabled: false
    };

  }

  goToDashboard(){
    let path = `dashboard`;
    this.props.history.push(path);
  }

  change(event, stateName, type) {

    switch (type) {
      case "password":
        if (verifyPassword(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "passwordMatch":
        if (event.target.value && event.target.value === this.state.password1) {
          this.setState({
            [stateName + "State"]: "success",
            showPasswordMismatch: false
          });
        } else {
          this.setState({
            [stateName + "State"]: "error",
            showPasswordMismatch: true
          });
        }
        break;
      default:
        break;
    }

    this.setState({ [stateName]: event.target.value });
  }

  handleSubmit = event => {
    event.preventDefault();
    if (this.state.password1State === 'success' && this.state.password2State === 'success') {
      this.setState({
        responseMessage: 'logging in',
        loginButtonDisabled: true
      })
      const passwordData = {
        userId: sessionStorage.getItem('userId'),
        password: this.state.password1
      }
      axios.post(`${API_ROOT}/auth/resetPassword/`, passwordData, { headers: getApiHeaders() })
        .then(res => this.handlePasswordResponse(res.data));
    } else {
      this.setState({ responseMessage: 'Please enter a password that meets the password requirements.' })
    }
  }
  handlePasswordResponse(res) {
    if (this._isMounted) {
      if (res.message) {
        if (res.message === 'success') {
          this.goToDashboard()
        } else {
          this.setState({
            responseMessage: res.message,
            loginButtonDisabled: false
          });
        }

      } else {
        this.setState({
          responseMessage: 'There was an unknown error.',
          loginButtonDisabled: false
        });
      }
    }
  }

  componentDidMount() {
    this._isMounted = true;
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    this._isMounted = false;
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }



  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <PreLoginHeader />
        <GridContainer justifyContent="center">
          <GridItem xs={12} sm={6} md={4}>
            <form onSubmit={this.handleSubmit}>
              <Card login className={classes[this.state.cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="cirrusBlue"
                >
                  <h4 className={classes.cardTitle}>Enter a new password</h4>
                </CardHeader>
                <CardBody>

                  <CustomInput
                    success={this.state.password1State === "success"}
                    error={this.state.password1State === "error"}
                    labelText={
                      <span>
                Password <small>(required)</small>
              </span>
                    }
                    id="password1"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: event => this.change(event, "password1", "password"),
                      type: "password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}>
                            lock_outline
                          </Icon>
                        </InputAdornment>
                      )
                    }}
                  />
                  <p>
                    Your password must be at least 8 characters long, contain a number, an uppercase letter, a lowercase letter and a special character (!#@$%^&*)(+=._-).
                  </p>
                  <CustomInput
                    success={this.state.password2State === "success"}
                    error={this.state.password2State === "error"}
                    labelText={
                      <span>
                Password, again <small>(required)</small>
              </span>
                    }
                    id="password2"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      onChange: event => this.change(event, "password2", "passwordMatch"),
                      type: "password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}>
                            lock_outline
                          </Icon>
                        </InputAdornment>
                      )
                    }}
                  />
                  <p style={this.state.showPasswordMismatch ? {} : { display: 'none' }}>
                    The passwords do not match.
                  </p>
                  <div className={classes.center}>
                    <Danger>{this.state.responseMessage}</Danger>
                  </div>
                </CardBody>
                <div className={classes.justifyContentCenter}>
                  <Button id="enterNewPasswordButton" color="cirrusBlue" simple size="lg" block type="submit" disabled={this.state.loginButtonDisabled}>
                    Reset
                  </Button>
                </div>
              </Card>
            </form>
          </GridItem>

        </GridContainer>
        <Footer fluid />
      </div>
    );
  }
}

EnterNewPassword.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(EnterNewPassword);
